import {
  Widget,
  WidgetFC,
  WidgetProps,
  WidgetTemplate
} from '../index.d'
import {
  WidgetPropType
} from 'index.pt'
import _ from 'lodash'
import PT from 'prop-types'
import React from 'react'
import ReactResizeDetector from 'react-resize-detector'
import { Accordion } from '@navikt/ds-react'

const EkspandertBartWidget: WidgetFC<WidgetProps> = ({ onResize, onUpdate, widget }: WidgetProps): JSX.Element => {
  const onClick = (): void => {
    const newWidget: Widget = _.cloneDeep(widget)
    newWidget.options.collapsed = !newWidget.options.collapsed
    onUpdate(newWidget)
  }

  const _onResize = (w?: number, h?: number): void => {
    // give more 50 for the panel header
    if (w !== undefined && h !== undefined) {
      onResize(w, h + 60)
    }
  }

  return (
    <div className='w-EkspandertbartWidget'>
      <Accordion>
        <Accordion.Item open={!widget.options.collapsed}>
          <Accordion.Header onClick={onClick}>{widget.title}</Accordion.Header>
          <Accordion.Content>

            <div>
              <ReactResizeDetector
                handleWidth
                handleHeight
                onResize={_onResize}
              />
              {widget.options.collapsed === true
                ? ''
                : (
                  <div
                    className='content'
                    dangerouslySetInnerHTML={{ __html: widget!.options.content }}
                  />
                  )}
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion>
    </div>
  )
}

const properties: WidgetTemplate = {
  type: 'ekspandertbart',
  title: 'Ekspandertbart widget',
  description: 'Widget that can collapse',
  layout: {
    lg: { minW: 6, maxW: 12, defaultW: 6, minH: 2, maxH: 999, defaultH: 6 },
    md: { minW: 2, maxW: 3, defaultW: 2, minH: 2, maxH: 999, defaultH: 3 },
    sm: { minW: 1, maxW: 1, defaultW: 1, minH: 2, maxH: 999, defaultH: 3 }
  },
  options: {
    collapsed: false,
    content: ''
  }
}
EkspandertBartWidget.properties = properties
EkspandertBartWidget.propTypes = {
  content: PT.string,
  onResize: PT.func.isRequired,
  onUpdate: PT.func.isRequired,
  widget: WidgetPropType.isRequired
}

export default EkspandertBartWidget
